import {
  REDUCER_NAMES_UNIVERSAL_CUSTOMER_REPRESENTATIVES as defaultSlice,
} from '../../constants'


// Returns undefined if no such reptype exists
export const getUniversalCustomerRep = (state, repType) => (
  state[defaultSlice][repType]
)
